import React from 'react';
import FlexBox from "./FlexBox";

const RoundedLabel = ({value, background= "#EFEFEF", color = "#000000", style={}}) => {
    return (
        <FlexBox style={{
            borderRadius: "50%",
            background: background,
            width: "48px",
            height: "48px",
            fontWeight: "500",
            fontSize: "16px",
            lineHeight:"normal",
            color: color
        ,...style}}>{value}</FlexBox>
    )
};

export default RoundedLabel;